import { render } from "./popoverComponent.vue?vue&type=template&id=3e2289a3&scoped=true"
import script from "./popoverComponent.vue?vue&type=script&lang=js"
export * from "./popoverComponent.vue?vue&type=script&lang=js"

import "./popoverComponent.vue?vue&type=style&index=0&id=3e2289a3&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2289a3"]])

export default __exports__